<template>
	<div class="sing-up-container">
		<DeliveryFinish v-if="status_finish_delivery" :form="service_info" @closeFinish="status_finish_delivery = $event"></DeliveryFinish>
		<div class="sign-up-content" v-show="!status_finish_delivery">
			<div class="general-title">
				<i class="fas fa-chevron-left" @click="back()"></i>
				<h4>{{ status_header }}</h4>
				<span></span>
			</div>
			<div class="figure" id="map2">
				
			</div>
			<div class="description-location">
				<h4>¿A donde iremos?</h4>
				<div class="custom-input-container s1">
					<i class="fas fa-map-pin"></i>
					<input type="text" placeholder="Dirección de origen" id="complete_origin">
				</div>
				<div class="separator">
					<div class="spacer"></div>
				</div>
				<div class="custom-input-container mtc s2">
					<i class="fas fa-map-pin"></i>
					<input type="text" placeholder="Destino" id="complete_destiny">
				</div>
				<div class="description-delivery">
					<input type="text" placeholder="Indicaciones adicionales" v-model="aditional_info">
				</div>
				<div class="term-and-cond" @click="double_service = true">
					<label class="container-check">¿Es ida y vuelta?
  						<input type="checkbox">
 						<span class="checkmark"></span>
					</label>
				</div>
				<div class="confirm-button">
					<button @click="validateService()">Continuar</button>
				</div>
			</div>
		</div>	
	</div>
	
</template>

<style scoped>

	*:focus{
		outline: none !important;
	}

	.description-delivery{
		width: 100%;
		height: auto;
		margin-top: 10px;
	}

	.description-delivery input{
		width: 100%;
		border: 1px solid #EEEEF2;
		border-radius: 5px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		padding: 15px 15px 30px 15px;
	}

	.sing-up-container{
		width: 100%;
		height: 100vh;
		background-size: cover;
		background-position: center bottom;
	}

	.error{
		border: 1px solid red !important;
	}

	.sign-up-content{
		width: 100%;
		height: auto;
		display: block;
	}

	.general-title{
		width: 100%;
		background: #0E115D;
		height: 13vh;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0px 15px;
	}

	.general-title i{
		color: #fff;
		font-size: 15px;
	}

	.general-title h4{
		color: #252529;
		font-size: 19px;
		color: #fff;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		margin-bottom: 0;
	}

	.figure{
		width: 100%;
		height:35vh;
		margin-top: -15px;
		border-radius: 20px;
	}

	.description-location{
		background: #fff;
		border-radius: 20px;
		text-align: left;
		padding: 20px;
	}

	.description-location h4{
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		font-size: 16px;
		margin-bottom: 10px;
	}

	.custom-input-container{
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		border: 1px solid #EEEEF2;
		padding: 15px;
		border-radius: 10px;
	}

	.custom-input-container input{
		width: 93%;
		border: none;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		font-size: 16px;
	}

	.custom-input-container i{
		font-size: 17px;
		margin-right: 10px;
		color: #0E115D;
	}

	.separator{
		width: 100%;
		height: auto;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 7px 0px;
	}

	.term-and-cond{
		width: 100%;
		padding: 15px 0px 0px 0px;
		text-align: left;
	}

	.term-and-cond label{
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		font-size: 15px;
		text-align: left;
		color: #757575;
	}

	.container-check {
	 	display: block;
		position: relative;
		padding-left: 35px;
		margin-bottom: 12px;
		cursor: pointer;
		font-size: 22px;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	/* Hide the browser's default checkbox */
	.container-check input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
		height: 0;
		width: 0;
	}

	/* Create a custom checkbox */
	.checkmark {
		position: absolute;
		top: 0;
		left: 0;
		height: 25px;
		width: 25px;
		background-color: #F1F1F5;
		border-radius: 5px;
	}

	/* On mouse-over, add a grey background color */
	.container-check:hover input ~ .checkmark {
	  background-color:#F0F5FE;
	}

	.container-check input:checked ~ .checkmark {
	  background-color: #0A58ED;
	}

	/* Create the checkmark/indicator (hidden when not checked) */
	.checkmark:after {
	  content: "";
	  position: absolute;
	  display: none;
	}

	/* Show the checkmark when checked */
	.container-check input:checked ~ .checkmark:after {
	  display: block;
	}

	/* Style the checkmark/indicator */
	.container-check .checkmark:after {
	  left: 9px;
	  top: 5px;
	  width: 5px;
	  height: 10px;
	  border: solid white;
	  border-width: 0 3px 3px 0;
	  -webkit-transform: rotate(45deg);
	  -ms-transform: rotate(45deg);
	  transform: rotate(45deg);
	}

	.confirm-button{
		width: 100%;
		text-align: center;
		padding-top: 15px;
	}

	.confirm-button button{
		width: 100%;
		padding: 13px 0px;
		font-size: 16px;
		font-weight: 500;
		border: none;
		font-family: 'Poppins', sans-serif;
		background: #0E115D;
		border-radius: 6px;
		color: #fff;
	}

</style>

<script>
	import DeliveryFinish from './DeliveryFinish.vue';
	export default{
		props: ['form'],
		components:{
			DeliveryFinish
		},
		data(){
			return{
				status_header: "",
				status_finish_delivery: false,
				double_service: false,
				origin_address: "",
				destiny_address: "",
				aditional_info: "",
				latitude: "",
				longitude: "",
				latitude2: "",
				longitude2: "",
				origin_aux: "",
				destiny_aux: "",
				distance: "",
				service_info: {}
			}
		},
		methods:{
			back(){
				this.$emit('closeCheckout',false);
			},
			updateHeader(){
				if (this.form.id_type_service == 79) {
					this.status_header = this.form.name;
				}
				if (this.form.id_type_service == 80) {
					this.status_header = this.form.name;
				}
				if (this.form.id_type_service == 81) {
					this.status_header = this.form.name;
				}
				if (this.form.id_type_service == 82) {
					this.status_header = this.form.name;
				}
			},
			initMap(){
				var self = this;
				var map = new google.maps.Map(document.getElementById('map2'), {
			        zoom: 13.8,
			        center: {lat: 10.471864459868115, lng: -73.26583531981072}, // Centramos el mapa al area
			        disableDefaultUI: true,
		      	});
		      	var options = {
        			//types: ['establishment'],
        			componentRestrictions: {country: "co"}
      			};
      			//creamos los marcadores que serán visibles en el mapa
		      	const marker = new google.maps.Marker({map: map, draggable: false});
		      	const marker2 = new google.maps.Marker({map: map, draggable: false});

		      	//selecciones los input por el id para realizar el autocompletado
		      	const autocompleteOrigin = document.getElementById('complete_origin');
		      	const autocompleteDestiny = document.getElementById('complete_destiny');

		      	//realizamos la instancia de la variable autocomplete de google maps
		      	const autocompleteOriginObj = new google.maps.places.Autocomplete(autocompleteOrigin, options);
		      	const autocompleteDestinyObj = new google.maps.places.Autocomplete(autocompleteDestiny, options);


		      	//añadimos evento listener a ambos input para realizar el autocompletado de la direccion
		      	autocompleteOriginObj.addListener('place_changed', function () {
        			marker.setVisible(false);
        			var place = autocompleteOriginObj.getPlace();
        			if (!place.geometry) {
          				window.alert('Sin detalles disponibles para: \'' + place.name + '\'');
          				return;
        			}
        			self.renderAddress(map,marker,place);
        			self.setAdrress(place.formatted_address, 1);
        			self.origin_aux = place.formatted_address;
      			});

      			autocompleteDestinyObj.addListener('place_changed', function () {
        			marker2.setVisible(false);
        			var place2 = autocompleteDestinyObj.getPlace();
        			if (!place2.geometry) {
          				window.alert('Sin detalles disponibles para: \'' + place2.name + '\'');
          				return;
        			}
        			self.renderAddress(map,marker2,place2);
        			self.setAdrress(place2.formatted_address, 2);
        			self.destiny_aux = place2.formatted_address;
        			if (self.latitude != "" && self.longitude != "") {
        				self.traceRoute(map, self.latitude, self.longitude, self.origin_aux, self.destiny_aux);
        				marker.setVisible(false);
        				marker2.setVisible(false);
        			}
      			});
			},
			traceRoute(mapa, latitude, longitude, origine, destiny){
				var self = this;
				//creamos la instancia del objeto latitud, longitud de google maps para configurar la posicion inicial de la ruta
				var gLatLon = new google.maps.LatLng(latitude, longitude);

				//creamos los objetos de confirguracion del directions service y renderer
				var objConfigDR = {
					map: mapa 
				}
				var objConfigDS = {
					origin: origine,
					destination: destiny,
					travelMode: google.maps.TravelMode.DRIVING
				}
				//creamos las instancias de los servicios de google a utilizar
				var ds = new google.maps.DirectionsService();
				var dr = new google.maps.DirectionsRenderer(objConfigDR);

				//realizamos la funcion que traza la ruta entre los puntos de origen y destino
				function fnRutear(resultados, status){
					if (status == 'OK') {
						dr.setDirections(resultados);
					}else{
						console.log("hubo un error" + status)
					}
				}

				//llamamos al metodo que realizará la traza
				ds.route(objConfigDS, fnRutear)
			},
			setAdrress(place, id){
		      var self = this;
		      var geocoder = new google.maps.Geocoder();
		      geocoder.geocode({address: place}, function(results, status) {
		        if (status === google.maps.GeocoderStatus.OK) {
		          var result = results[0].geometry.location; // el primer resultado es el más relevante
		          if(id == 1){
		          	console.log("exito1");
		          	self.latitude = result.lat();
		          	self.longitude = result.lng();
		          	localStorage.setItem('longitud_delivery', self.longitude);
		          	localStorage.setItem('latitud_delivery', self.latitude);
		          }
		          if(id == 2){
		          	console.log("exito2");
		          	self.latitude2 = result.lat();
		          	self.longitude2 = result.lng();
		          }
		        } else {
		          console.log('Google respondió:',status);
		        }
		      });
		    }, 
		    renderAddress(mapa, marker, place){
		      mapa.setCenter(place.geometry.location);
		      marker.setPosition(place.geometry.location);
		      marker.setVisible(true);
		    },
		    degreesToRaddians(degrees){
		    	return degrees * Math.PI / 180;
		    },
		    getDistanceBetweenPoints(lat1, lng1, lat2, lng2){
		    	//el radio del planeta tierra en metros
		    	let R = 6378137;
		    	let dLat = this.degreesToRaddians(lat2 - lat1);
		    	let dLong = this.degreesToRaddians(lng2 - lng1);
		    	let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(this.degreesToRaddians(lat1)) * Math.cos(this.degreesToRaddians(lat1)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
		    	let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		    	let distance = R * c;
		    	this.distance = parseFloat(distance * 0.001);
		    },
		    validateService(){
		    	var self = this;
		    	//accedemos a los valores de cada uno de los inputs del formulario
		    	let autocompleteOrigin = document.getElementById('complete_origin').value;
		      	let autocompleteDestiny = document.getElementById('complete_destiny').value;

		      	//validamos los campos vacios al momento de enviar el formulario hacia el otro componente
		      	if (autocompleteOrigin == "" || autocompleteDestiny == "") {
		      		$(".s1").addClass("error");
		      		$(".s2").addClass("error");
		      	}else{
		      		self.getDistanceBetweenPoints(self.latitude, self.longitude, self.latitude2, self.longitude2);
		      		self.service_info = {
		      			'origin_address' : self.origin_aux,
		      			'destiny_address': self.destiny_aux,
		      			'double_service' : self.double_service,
		      			'distance' : self.distance,
		      			'service': self.status_header,
		      			'aditional_info': self.aditional_info,
		      			'id_type_service': self.form.id_type_service,
		      			'id_product': self.form.id
		      		}
		      		self.status_finish_delivery = true;
		      	}
		    }
		},
		mounted(){
			var self = this;
			self.updateHeader();
			setTimeout(function(){
		      self.initMap();
		    },500);
		}
	}
</script>